import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      fill: "#00365E"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FCDE00",
      d: "m12.03 3.84.297.913h.957l-.776.562.297.913-.775-.561-.776.561.297-.913-.776-.562h.957zM12.03 17.767l.297.913h.957l-.776.567.297.913-.775-.566-.776.566.297-.913-.776-.567h.957zM15.407 16.843l.297.913h.957l-.775.561.297.913-.776-.566-.781.566.297-.913-.775-.561h.962zM8.488 16.843l.297.913h.957l-.775.561.297.913-.776-.566-.776.566.297-.913-.775-.561h.957zM15.407 4.781l.297.914h.957l-.775.56.297.92-.776-.567-.781.567.297-.92-.775-.56h.962zM8.488 4.781l.297.914h.957l-.775.56.297.92-.776-.567-.776.567.297-.92-.775-.56h.957zM6.04 14.306l.298.913H7.3l-.781.567.297.914-.776-.567-.775.567.297-.914-.776-.567h.957zM18.02 14.306l.297.913h.963l-.781.567.297.914-.776-.567-.775.567.297-.914-.776-.567h.957zM6.04 7.4l.298.913H7.3l-.781.562.297.913-.776-.567-.775.567.297-.913-.776-.562h.957zM5.094 10.8l.297.908h.963l-.776.567.292.913-.776-.56-.775.56.297-.913-.776-.567h.957zM18.907 10.8l.297.908h.957l-.776.567.297.913-.775-.56-.776.56.291-.913-.775-.567h.963zM18.02 7.4l.297.913h.963l-.781.562.297.913-.776-.567-.775.567.297-.913-.776-.562h.957z"
    }, null, -1)
  ])))
}
export default { render: render }